import React from 'react';
import { Navigate } from 'react-router-dom';
import { pr, r } from './helpers';
import {
  DashboardPage,
  BranchDashboardPage,
  UsersPage,
  BranchesPage,
  BranchDetailPage,
  BranchSelectPage,
  RidersPage,
  RiderMonitoringPage,
  DispatchCenterPage,
  NewBranchShipmentPage,
  BranchShipmentsListPage,
  BranchShipmentDetailPage,
  BranchShipmentRoutesPage,
  WarehousesPage,
  WarehouseProductsPage,
  NewWarehouseOrderPage,
  WarehouseSpacesPage,
  CompanyWarehouseReportPage,
  MerchantsPage,
  MerchantDetailPage,
  OrdersPage,
  CompanyBulkUploadPage,
  CompanyBulkUpdatePage,
  OrderDetailPage,
  NotificationsPage,
  ReportsPage,
  RiderSettlementsPage,
  MerchantPayoutsPage,
  ExpensesPage,
  AccountingPage,
  CompanySettingsPage,
  CompanyWorkflowPage,
  NotificationSettingsPage,
  LabelDesignerPage,
  ReportDesignerPage,
  LabelPage,
  BatchLabelsPage,
  TenantProfilePage,
} from '../lazyPages';

const STAFF = ['company', 'user'];

/** Company staff portal routes (authenticated on company subdomain or apex). */
export function CompanyProtectedRoutes() {
  return (
    <>
      {pr('/branch-select', BranchSelectPage, STAFF)}
      {pr('/b/:branchCode', BranchDashboardPage, STAFF, undefined, 'branches.view')}
      {pr('/', DashboardPage, STAFF, undefined, 'dashboard.view')}
      {pr('/users', UsersPage, STAFF, undefined, 'users.view')}
      {r('/roles', <Navigate to="/users" replace />)}
      {pr('/branches', BranchesPage, STAFF, undefined, 'branches.view')}
      {pr('/branches/:branchId', BranchDetailPage, STAFF, undefined, 'branches.view')}
      {pr('/riders', RidersPage, STAFF, undefined, 'riders.view')}
      {pr('/rider-monitoring', RiderMonitoringPage, STAFF, undefined, 'riders.monitor')}
      {r('/rider-monitoring/map', <Navigate to="/dispatch-center" replace />)}
      {pr('/dispatch-center', DispatchCenterPage, STAFF, undefined, 'dispatch.view')}
      {pr('/shipments/new', NewBranchShipmentPage, STAFF, undefined, 'shipments.create')}
      {pr('/shipments/outgoing', BranchShipmentsListPage, STAFF, undefined, 'shipments.view')}
      {pr('/shipments/incoming', BranchShipmentsListPage, STAFF, undefined, 'shipments.view')}
      {pr('/shipments/routes', BranchShipmentRoutesPage, STAFF, undefined, 'shipments.create')}
      {pr('/shipments/:id', BranchShipmentDetailPage, STAFF, undefined, 'shipments.view')}
      {pr('/warehouses/products', WarehouseProductsPage, STAFF, undefined, 'warehouse_products.view')}
      {pr('/warehouses/orders/new', NewWarehouseOrderPage, STAFF, undefined, 'warehouse_orders.create')}
      {pr('/warehouses/spaces', WarehouseSpacesPage, STAFF, undefined, 'warehouses.view')}
      {pr('/warehouses/report', CompanyWarehouseReportPage, STAFF, undefined, 'warehouse_reports.view')}
      {pr('/warehouses', WarehousesPage, STAFF, undefined, 'warehouses.view')}
      {pr('/merchants', MerchantsPage, STAFF, undefined, 'merchants.view')}
      {pr('/merchants/:merchantId', MerchantDetailPage, STAFF, undefined, 'merchants.view_details')}
      {pr('/orders', OrdersPage, STAFF, undefined, 'orders.view')}
      {pr('/orders/bulk', CompanyBulkUploadPage, STAFF, undefined, 'orders.create')}
      {pr('/orders/bulk-update', CompanyBulkUpdatePage, STAFF, undefined, 'orders.edit')}
      {pr('/orders/labels/batch', BatchLabelsPage, STAFF, undefined, 'orders.export')}
      {pr('/orders/:orderId/label', LabelPage, STAFF, undefined, 'orders.export')}
      {pr('/orders/:orderId', OrderDetailPage, STAFF, undefined, 'orders.view')}
      {pr('/notifications', NotificationsPage, STAFF, undefined, 'notifications.view')}
      {pr('/reports', ReportsPage, STAFF, undefined, 'reports.view')}
      {pr('/rider-settlements', RiderSettlementsPage, STAFF, undefined, 'rider_settlements.view')}
      {pr('/merchant-payouts', MerchantPayoutsPage, STAFF, undefined, 'merchant_settlements.view')}
      {pr('/expenses', ExpensesPage, STAFF, undefined, 'expenses.view')}
      {pr('/accounting', AccountingPage, STAFF, undefined, 'accounting.view')}
      {pr('/settings', CompanySettingsPage, STAFF, undefined, 'settings.view')}
      {pr('/workflow', CompanyWorkflowPage, STAFF, undefined, 'workflow.view')}
      {pr('/settings/notifications', NotificationSettingsPage, STAFF, undefined, 'notifications.view')}
      {pr('/label-designer', LabelDesignerPage, STAFF, { companyMode: true }, 'orders.export')}
      {pr('/report-designer', ReportDesignerPage, STAFF, undefined, 'reports.design')}
      {pr('/profile', TenantProfilePage, STAFF, undefined, 'profile.view')}
    </>
  );
}